export const ORG_RESTRICTIONS_ZEE_LIST = ['Spray-Net'];
